module.exports = __webpack_public_path__ + "img/FGr_Sprengen.612cb3d9.svg";